import React from "react";
import {Box, Columns} from "react-bulma-components";
import Figure from "../../Utils/Figure";


export default function FiguresDisplay({figuresLoaded, figuresData}){


    return (
        <Box>
            <Columns>
                <Figure
                    label={"Total Value"}
                    loaded={figuresLoaded}
                    value={"£"+figuresData}
                />
            </Columns>
        </Box>
    )

}